import { RouterModule, Routes } from '@angular/router';
import { ViewRepurchaseComponent } from './components/view-repurchase/view-repurchase.component';
import { HomeRepurchaseComponent } from './components/home-repurchase/home-repurchase.component';
import { ListRepurchaseComponent } from './components/list-repurchase/list-repurchase.component';
import { ListRepurchaseRenewalComponent } from './components/list-repurchase-renewal/list-repurchase-renewal.component';


export const RepurchaseRouter: Routes = [
    { path: '', component: HomeRepurchaseComponent },
    { path: 'create', component: ViewRepurchaseComponent },
    { path: 'view/:id', component: ViewRepurchaseComponent },
    { path: 'list', component: ListRepurchaseComponent },
    { path: 'renewal/list', component: ListRepurchaseRenewalComponent },
];


// WEBPACK FOOTER //
// ./src/app/repurchase/repurchase.router.ts